import {
  MuiBox,
  MuiButtonPrimary,
  MuiGrid,
  MuiTypography,
} from "../../../../components";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { selectReportSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { IdNameList } from "../../../../api/services/common/models";
import { ReportSearchFormController } from "./ReportSearchFormControls";

interface ReportsSearchFormProps {
  reportCategories: IdNameList[];
  reportTypes: IdNameList[];
  handleCategoryChange: (categoryId: string) => void;
}

export const ReportsSearchForm = ({
  reportCategories,
  reportTypes,
  handleCategoryChange,
}: ReportsSearchFormProps) => {
  const { useFetchLabel, fetchComponentTitle } = useSiteCore();
  const getLabel = useFetchLabel(selectReportSiteCoreKeys.header);
  const headerLabel = fetchComponentTitle(selectReportSiteCoreKeys.header);

  return (
    <MuiBox className="selectReportContainer">
      <MuiBox className="result-header">
        <MuiTypography variant="h2SemiBold" className="header-text">
          {headerLabel}
        </MuiTypography>
      </MuiBox>
      <MuiBox className="selectReportFieldContainer">
        <MuiGrid container columnSpacing={2} rowSpacing={2}>
          <ReportSearchFormController
            reportCategories={reportCategories}
            reportTypes={reportTypes}
            handleCategoryChange={handleCategoryChange}
          />
          <MuiGrid
            size={{ lg: 4, md: 6, xs: 12, sm: 12 }}
            className="view-reports-button-container"
          >
            <MuiButtonPrimary type="submit">
              {getLabel(selectReportSiteCoreKeys.viewReportsButton)}
            </MuiButtonPrimary>
          </MuiGrid>
        </MuiGrid>
      </MuiBox>
    </MuiBox>
  );
};
